import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { compensationApi } from '../../../api/compensation.js';

const money = (v, c = 'IDR') => (v == null ? '—' : `${c} ${Number(v).toLocaleString('en-US')}`);

export default function Cycles() {
  const [items, setItems] = useState([]);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState(null);

  function refresh() {
    setLoading(true);
    Promise.all([compensationApi.listCycles(), compensationApi.listPlans()])
      .then(([c, p]) => {
        setItems(c?.items || []);
        setPlans(p?.items || []);
      })
      .catch((e) => setError(e.response?.data?.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }
  useEffect(refresh, []);

  async function submit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    try {
      await compensationApi.createCycle({
        name: fd.get('name'),
        planId: fd.get('planId') || null,
        periodStart: fd.get('periodStart') || null,
        periodEnd: fd.get('periodEnd') || null,
        budgetAmount: fd.get('budgetAmount') ? Number(fd.get('budgetAmount')) : null,
        budgetCurrency: fd.get('budgetCurrency') || 'IDR',
      });
      form.reset();
      setShowForm(false);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create');
    }
  }

  async function open(id) {
    try {
      await compensationApi.openCycle(id);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to open cycle');
    }
  }

  return (
    <section data-testid="comp-cycles-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div>
          <h1>Compensation Cycles</h1>
          <p className="muted">{items.length} cycles</p>
        </div>
        <button className="btn primary" data-testid="comp-cycle-create" onClick={() => setShowForm((s) => !s)}>
          {showForm ? 'Close' : '+ New Cycle'}
        </button>
      </header>

      {error && <div className="alert error" data-testid="comp-cycles-error">{error}</div>}

      {showForm && (
        <form onSubmit={submit} className="card form-card grid-form">
          <label>Name<input name="name" data-testid="comp-cycle-name-input" required /></label>
          <label>Plan
            <select name="planId" data-testid="comp-cycle-plan-input" defaultValue="">
              <option value="">— none —</option>
              {plans.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </label>
          <label>Budget Amount<input name="budgetAmount" type="number" min="0" data-testid="comp-cycle-budget-input" /></label>
          <label>Currency<input name="budgetCurrency" defaultValue="IDR" /></label>
          <label>Period Start<input name="periodStart" type="date" /></label>
          <label>Period End<input name="periodEnd" type="date" /></label>
          <div className="full actions"><button className="btn primary" type="submit" data-testid="comp-cycle-submit">Create</button></div>
        </form>
      )}

      <div className="card">
        <table className="data-table" data-testid="comp-cycle-list">
          <thead>
            <tr><th>Name</th><th>Plan</th><th>Budget</th><th>Period</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} data-testid={`comp-cycle-row-${c.id}`}>
                <td><Link to={`/compensation/cycles/${c.id}/worksheet`}>{c.name}</Link></td>
                <td>{c.plan_name || '—'}</td>
                <td>{money(c.budget_amount, c.budget_currency)}</td>
                <td>{c.period_start ? String(c.period_start).slice(0, 10) : '—'} → {c.period_end ? String(c.period_end).slice(0, 10) : '—'}</td>
                <td><span className={`chip status-${c.status}`} data-testid={`comp-cycle-status-${c.id}`}>{c.status}</span></td>
                <td>
                  {c.status === 'draft' && (
                    <button className="btn" data-testid={`comp-cycle-open-${c.id}`} onClick={() => open(c.id)}>Open</button>
                  )}
                </td>
              </tr>
            ))}
            {!loading && items.length === 0 && <tr><td colSpan={6} className="muted">No cycles yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
